import { useState } from 'react';
import { useAuthContext } from 'hooks/useAuthContext';
import { MobileNavButton } from './MobileNavButton';
import { MobileNavDrawer } from './MobileNavDrawer';
import { StyledMobileNavAppBar, StyledMobileNavToolbar, StyledMobileNavLogo } from './MobileNav.styles';

export const MobileNav = () => {
  const { userState } = useAuthContext();
  const [open, setOpen] = useState(false);

  if (!userState.user.userId) {
    return null;
  }

  return (
    <>
      <StyledMobileNavAppBar position="relative">
        <StyledMobileNavToolbar>
          <StyledMobileNavLogo src="ISSVR_Logo.png" alt="logo" />
          <MobileNavButton onClick={() => setOpen(true)} />
        </StyledMobileNavToolbar>
      </StyledMobileNavAppBar>
      <MobileNavDrawer open={open} onClose={() => setOpen(false)} />
    </>
  );
};
